import { RepositoryBuildStatus } from 'src/redux/global/utils';
import { createHttpRequest } from 'src/utils/http-request';

export type WorkspaceRepositoriesApi = {
  getBuildStatuses: (body: string) => Promise<RepositoryBuildStatus[]>;
};

export const getWorkspaceRepositoriesApi = (
  url: string
): WorkspaceRepositoriesApi => ({
  getBuildStatuses: (body: string) => {
    const headerOptions = {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    };
    return createHttpRequest<RepositoryBuildStatus[]>('POST', {
      headers: headerOptions,
    })(url, body);
  },
});
